type AuthParams = {
	openIDProfile: string;
	systemName: string;
	applicationScope: string;
	businessService: string;
	businessServiceID: number;
	tariffCode: string;
};

function getAuthParams(): AuthParams {
	return {
		openIDProfile: window['__CONFIG_KEY__']['openIDProfile'],
		systemName: window['__CONFIG_KEY__']['systemName'],
		applicationScope: window['__CONFIG_KEY__']['applicationScope'],
		businessService: window['__CONFIG_KEY__']['businessService'],
		businessServiceID: window['__CONFIG_KEY__']['businessServiceID'],
		tariffCode: window['__CONFIG_KEY__']['tariffCode']
	};
}

export {
	getAuthParams,
};
